import { Level3Detail } from '@1po/1po-bff-fe-spec/generated/catalog/tree/request/Level3Detail';
import { BusinessError } from '@1po/1po-bff-fe-spec/generated/error/BusinessError';
import { WsResponse } from 'domains/webSockets/WebSocket.types';

export const getFirstVehicleKey = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'VEHICLE_KEY')?.value;
};

export const getFirstIAMVehicleCode = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'VEHICLE_IAM_CODE')?.value;
};

export const getFirstSearchText = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'SEARCH_TEXT')?.value;
};

export const getFirstBuyer = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'BUYER')?.value;
};

export const getFirstSearchDescription = (action: WsResponse): string | undefined => {
  const data = action.payload as BusinessError;
  return data?.errorDetail?.find(({ name }) => name === 'SEARCH_DESCRIPTION')?.value;
};

export const getFirstSeller = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'SELLER')?.value;
};

export const getFirstNodeId = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'NODE_ID')?.value;
};

export const getFirstGarageId = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'GARAGE_ID')?.value;
};

export const getFirstPlateId = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'PLATE_ID')?.value;
};

export const getAllMultiPlateIds = (action: WsResponse<BusinessError>): Level3Detail[] | undefined => {
  return action.payload?.errorDetail
    ?.filter(({ name }) => name === 'MULTI_PLATE_ID')
    .map((ref) => ref.value)
    .map((id) => {
      return { nodeId: id, plateIds: [] };
    });
};
export const getFirstReference = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'REFERENCE')?.value;
};

export const getAllDocumentsId = (action: WsResponse<BusinessError>): string[] | undefined => {
  return action.payload?.errorDetail?.filter(({ name }) => name === 'DOCUMENTS_ID').map((ref) => ref.value);
};

export const getAllReferences = (action: WsResponse<BusinessError>): string[] | undefined => {
  return action.payload?.errorDetail?.filter(({ name }) => name === 'REFERENCE').map((ref) => ref.value);
};

export const getAllOperationIds = (action: WsResponse<BusinessError>): string[] | undefined => {
  return action.payload?.errorDetail
    ?.filter(({ name }) => name === 'EASY_BASKET_OPERATIONS_IDS')
    .map((operation) => operation.value);
};

export const getGenericPart = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'GENERIC_PART')?.value;
};

export const getFirstBrand = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'BRAND')?.value;
};

export const getFirstModel = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'MODEL')?.value;
};

export const getFirstModelType = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'MODEL_TYPE')?.value;
};

export const getFirstPromotionId = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'PROMOTION_ID')?.value;
};

export const getFirstPictureKey = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'IMAGE_KEY')?.value;
};

export const getFirstSearchId = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'SEARCH_ID')?.value;
};

export const getFirstInformationId = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'INFORMATION_ID')?.value;
};
export const getInformationsStatus = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'STATUS_TYPE')?.value;
};

export const getFirstVIN = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'VIN')?.value;
};

export const getFirstSellerId = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'SELLER_ID')?.value;
};

export const getFirstProvider = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'PROVIDER')?.value;
};

export const getDMSErrorCode = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'DMS_ERROR_CODE')?.value;
};

export const getDMSErrorMessage = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'DMS_ERROR_MSG')?.value;
};

export const getDMSErrorType = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'DMS_ERROR_TYPE')?.value;
};

export const getSecondDMSErrorCode = (action: WsResponse<BusinessError>): string | undefined => {
  return getSecondDmsError(action, 'DMS_ERROR_CODE');
};

export const getSecondDMSErrorMessage = (action: WsResponse<BusinessError>): string | undefined => {
  return getSecondDmsError(action, 'DMS_ERROR_MSG');
};

export const getSecondDMSErrorType = (action: WsResponse<BusinessError>): string | undefined => {
  return getSecondDmsError(action, 'DMS_ERROR_TYPE');
};

const getSecondDmsError = (action: WsResponse<BusinessError>, key: string): string | undefined => {
  const errors = action.payload?.errorDetail?.filter(({ name }) => name === key);

  if (!errors) {
    return undefined;
  }

  if (errors.length === 1) {
    return errors[0]?.value;
  }

  return errors[1]?.value;
};

export const getTireSearchStatus = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'SEARCH_PARAMS_BASE_64')?.value;
};

export const getFirstEstimateId = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'ESTIMATE_ID')?.value;
};

export const getFirstOrderNumber = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'ORDER_NUMBER')?.value;
};

export const getLaborTimeId = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'LABOR_TIME_ID')?.value;
};

export const getLaborTimeIds = (action: WsResponse<BusinessError>): string[] | undefined => {
  return action.payload?.errorDetail?.filter(({ name }) => name === 'LABOR_TIME_IDS').map((e) => e.value);
};

export const getClaimErrorMessage = (action: WsResponse<BusinessError>): string | undefined => {
  return action.payload?.errorDetail?.find(({ name }) => name === 'RP4_CLAIM_ERROR_MSG')?.value;
};
